<template>
  <config-base class="opc-ze-edit" ref="baseRef" :on="$listeners" :plan-type="planType" saas-mode="SUBSCRIPTION" show-plan-details>
    <template slot="config">
      <bought-license :type="type" />
      <capacity-config-list ref="configListRef" :config-plan-type="planType" :config-capacity-key="capacityKey" :configRowName='configRowName'></capacity-config-list>
      <div style="margin-top: 24px;" v-if="addMoreVisible"
           v-html="$t('billing.webinar.add_more_plan_link_capacity_new', [title, addFlowLink])">
      </div>
      <preview-payment class="opc-ze-edit__preview-payment" />
    </template>
  </config-base>
</template>

<script>
import _, {get, map} from "lodash";
import {mapGetters} from "vuex";
import {
  BILLING_CYCLE,
  planTypes
} from '@/common/constants';
import mxPlanConfig from '@/plans/EVENT_SAAS/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
// import { pageConfig } from '@/common/service/page-config';
import {getOnlinePlanName} from '@/common/product';
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/EVENT_SAAS/config/base.vue";
import addonMixin from "@/plans/mx/addon";
import replenishMixin from "@/components/capacity/mx/replenish";
import { plansof } from '@/utils/chain';
import standardPriceMixin from "@/components/capacity/mx/standard-price";
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { enableNewUIForZS } from '@/common/service/op-switch';
import TwoWayControlEdit from '@/plans/EVENT_SAAS/mixins/two-way-control-edit';
import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';

export const CapacityConfigListFactory = (mxPlanConfig) => ({
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [addonMixin, replenishMixin, standardPriceMixin, mxPlanConfig, enableNewUIForZS ? TwoWayControlEdit : {}],
  data () {
    return {
      msgInstance: null,
      showCycleAlert: true,
    }
  },
  computed: {
    ...mapGetters(['getCurrentMeetingPlans', 'getCurrentBasePlanInfo', 'boughtPlans', 'getBoughtMeetingPlans', 'basicConfig', 'currentEditPlan', 'basePlanTotalLicenses']),
    boughtCurrentPlans() {
      return plansof(this.boughtPlans).type(this.configPlanType).get();
    },
    planList() {
      return _.chain(this.planMapFlat)
        .filter((p) => {
          const isCurrentPlanType = p.type === this.configPlanType && p.isSaas;

          const isBoughtCapacity = map(this.boughtCurrentPlans, this.capacityKey).includes(p[this.capacityKey]);
          const otherBoughtCapacity = isBoughtCapacity  && this.currentEditPlan?.capacity !== p[this.capacityKey]
          const isValidType = isCurrentPlanType && !otherBoughtCapacity;

          if(this.isBulkLicenseAccount) return isValidType && (p.category === this.currentEditPlan.category);
          return isValidType;
        })
        .filter((p) => {
          const currentCapacity = _.get(this.currentEditPlan, [this.capacityKey]);
          // Can only be upgraded to a higher capacity
          if (this.disableDownSell && currentCapacity) {
            return p.capacity >= currentCapacity;
          }

          return p;
        })
        .value();
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    boughtCapacityList() {
      return [...new Set(map(this.boughtCurrentPlans, this.capacityKey))].filter(x => !!x);
    },
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount
    },
    disableDownSell() {
      return this.basicConfig?.downSellData?.disableDownSell
    },
    mx_planLicenseCount() {
      return this.mx_totalCapacityLicenseCount(this.visibleCapacityList[0], this.capacityKey);
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t('billing.addon_license_limit_tips', [this.title, this.$t(basePlanNameKey)])
    },
    addCapacityBtnVisible() {
      return false;
    },
    mx_showSelectCapacityDropdown() {
      return this.allCapacityOrderList.length > 1;
    },
    mx_licenseTips() {
      if (!this.totalLimitDesc) {
        return this.$t('billing.events.saas.capacityTips', [this.title]);
      }
      return this.totalLimitDesc;
    },
    mx_capacityTips() {
      if (enableNewUIForZS) return '';
      return this.$t('billing.events.saas.capacityTips', [this.title]);
    },
  },
  methods: {
    bulkLicenseAccountCycleDisabled(cycle) {
      // for edit
      // return this.isBulkLicenseAccount && currentCyclePlans.length === 0;
      return this.isBulkLicenseAccount && (cycle !== this.currentEditPlan.billing_cycle);
    },
    afterSwitchCapacityHook(oldSelectedPlan, newPlan) {
      if (!this.mx_showSelectCapacityDropdown) return
      this.mx_checkCapacityChanged(newPlan)
    },
    mx_getMonthlyPlan(capacityPlanList = []) {
      // const monthlyPlans = this.boughtCurrentPlans.filter(x => x.billing_cycle === BILLING_CYCLE.MONTHLY);
      const annualAddons = plansof(this.boughtPlans).filter(x => x.baseType == this.$context.type).type(planTypes.ADDITIONAL_CO_EDITOR, planTypes.ADDITIONAL_HOST).annual().get();
      const hasAnnualAddon = !!annualAddons.length;
      const isMonthlyDisabled = this.bulkLicenseAccountCycleDisabled(BILLING_CYCLE.MONTHLY) || hasAnnualAddon;

      const monthlyTooltips = this.bulkLicenseAccountCycleDisabled(BILLING_CYCLE.MONTHLY) && this.$t('billing.error.buld_acount_license')
      ||
      hasAnnualAddon && this.$t('billing.planform.can_not_select_monthly', [
        getOnlinePlanName(plansof(this.getSelectedPlans).type(this.$context.type).get(0)),
        getOnlinePlanName(annualAddons[0])
      ]) || '';

      const monthlyPlan = capacityPlanList.find(p => p.billing_cycle === BILLING_CYCLE.MONTHLY);

      const defaultDisabledBillingCycle = {
        disabled: true,
        disabledInnerDesc: this.$t('billing.events.onlyForAttendeesDesc', [100]),
      };

      const isSpecialBillingCycleEdit = ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(this.boughtCurrentPlans[0]?.billing_cycle);
      const isMultipleRatePlans = this.boughtCurrentPlans[0]?.ratePlans?.length > 1;
      const notShowDisabledBillingCycle = isSpecialBillingCycleEdit || isMultipleRatePlans;

      return {
        plan: monthlyPlan,
        ...(monthlyPlan ? {
          disabled: isMonthlyDisabled,
          tooltips: monthlyTooltips,
        } : notShowDisabledBillingCycle ? {} : { plan: { billing_cycle: BILLING_CYCLE.MONTHLY }, ...defaultDisabledBillingCycle }),
      };
    },
    mx_getBillingCycleList(capacity) {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey']);
      const { capacityMap, $t } = this;
      const capacityPlanList = capacityMap[capacity] || [];
      // const annualPlans = this.boughtCurrentPlans.filter(x => x.billing_cycle === BILLING_CYCLE.ANNUAL);
      const isAnnualDisabled = this.bulkLicenseAccountCycleDisabled(BILLING_CYCLE.ANNUAL) || this.mx_annualPlanDisabled.disabled
      const annualTooltips = this.bulkLicenseAccountCycleDisabled(BILLING_CYCLE.ANNUAL) ? $t('billing.error.buld_acount_license') : this.mx_annualPlanDisabled.reason;
      const annualDisabledAlert = annualTooltips || ([100].includes(this.currentEditPlan?.capacity) ? this.$t('billing.planform.annual_addon_disable_alert', [this.title, this.$t(basePlanNameKey)]) : null); // Shani the PM said "this is business decision"

      return [
        this.mx_getMonthlyPlan(capacityPlanList),
        {
          plan: capacityPlanList.find(p => p.billing_cycle === BILLING_CYCLE.ANNUAL),
          disabled: isAnnualDisabled,
          tooltips: annualTooltips,
          alert: annualDisabledAlert,
        },
        {
          plan: capacityPlanList.find(p => p.billing_cycle === BILLING_CYCLE.QUARTERLY),
        },
        {
          plan: capacityPlanList.find(p => p.billing_cycle === BILLING_CYCLE.TWO_YEARS),
        },
        {
          plan: capacityPlanList.find(p => p.billing_cycle === BILLING_CYCLE.THREE_YEARS),
        },
      ].filter(p => p.plan && !p.hidden);
    },
    // initVisibleCapacityList() {
    //   if (this.selectedPlanList?.length) {
    //     this.visibleCapacityList = map(this.selectedPlanList.filter(p => p.category === pageConfig?.subPlan || this.mx_showSelectCapacityDropdown), this.capacityKey);
    //   } else {
    //     this.visibleCapacityList = this.allCapacityOrderList.slice(0, 1);
    //   }
    // },
    handleLicenseChange(license) {
      this.mx_validDownSellLicense(license)
      if (license >= this.mx_getMaxHosts() && !this.mx_canAutoAdd && this.mx_getMaxHosts() !== 999) {
        this.mx_licenseAlert = this.editTotalLimitDesc
      } else if (this.mx_downSellLicenseErrorMessage) {
        this.mx_licenseAlert = this.mx_downSellLicenseErrorMessage
      } else {
        this.mx_licenseAlert = ''
      }
    },
    getCurrentCapacityList() {
      return this.allCapacityOrderList
    },
    showMessage(message) {
      this.msgInstance && this.msgInstance.close();
      this.msgInstance = this.$message({
        type: 'info',
        duration: 8000,
        message: message,
        showClose: true
      })
    },
    mx_getMinHosts(capacity) {
      // non standard price
      if (this.checkCurrentCapacityIsNonStandardPrice(capacity)) {
        return this.currentBoughtLicense;
      }

      // for edit
      if (this.disableDownSell) {
        return getPlanTotalLicense([this.currentEditPlan]) || 1;
      }
      return 1
    },
    mx_getMaxHosts() {
      return this.mx_canAutoAdd ? 999 : this.basePlanTotalLicenses || 999;
    },
    mx_getDecreaseTips(capacity) {
      const plans = (this.selectedPlanList || []).filter(x => x.type === this.configPlanType && x[this.capacityKey] === capacity);
      const currentCapacityPlanCount = getPlanTotalLicense(plans);
      const currentIsEqualPrev = currentCapacityPlanCount > 1 && currentCapacityPlanCount === this.mx_getMinHosts(capacity);

      if (this.checkCurrentCapacityIsNonStandardPrice(capacity) && currentIsEqualPrev) {
        return this.$t('billing.planform.meeting_license_custom_pricing');
      }

      if (currentIsEqualPrev) {
        return this.$t('billing.error.can_not_bought_plan_tips')
      }
      return ''
    },
    mx_onAddedBasePlan(basePlanName) {
      this.showMessage(
        this.$t('billing.addon_auto_add_tips', [this.title, basePlanName]),
      );
    },
    mx_onRemovedBasePlan(basePlanName) {
      this.showMessage(
        this.$t('billing.addon_auto_remove_tips', [this.title, basePlanName]),
      );
    },
  }
});

export default {
  mixins: [plansMixin, mxPlanConfig],
  components: {
    PreviewPayment,
    CapacityConfigList: CapacityConfigListFactory(mxPlanConfig),
    ConfigBase: {
      mixins: [ConfigBase, mxPlanConfig],
    },
    BoughtLicense,
  },
  data() {
    return { isMounted: false }
  },
  computed: {
    ...mapGetters(['isDisableAdd2Cart']),
    type(){
      return planTypes.EVENT_SAAS;
    },
    addFlowLink() {
      if (!this.isMounted) return;
      const { configListRef } = this.$refs;
      const basePlan = configListRef?.currentBasePlans[0] || {}
      const basePlanCount = getPlanTotalLicense(configListRef?.currentBasePlans || [])
      return `/opc/buy/add?plan=${basePlan?.category}&subPlan=newsubs&from_sub=${this.$query.subPlan}&type=add&majorPlanHost=${basePlanCount}`
    },
    addMoreVisible() {
      if (!this.isMounted) return;
      const { configListRef = {} } = this.$refs;
      const { boughtCapacityList = [], allCapacityOrderList = [] } = configListRef;
      return !this.isDisableAdd2Cart && allCapacityOrderList.some(x => !boughtCapacityList.includes(x));
    },
    configRowName() {
      if (enableNewUIForZS) {
        return 'CapacityConfigRowV2';
      }
      return 'CapacityConfigRow';
    }
  },
  mounted() {
    // Make $refs reactive in computed
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
.opc-ze-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
